import * as React from 'react';
import CsvDownloadButton from '../../../components/CsvDownloadButton';
import useUsers from '../hooks/useUsers';
import { formatDate } from '@moovly/dashboard-global';
import { t } from '@moovly/i18n';
import { UserData } from '../types/user';

const getStatus = (user: UserData) => {
  if (user.license && !user.license.is_expired) {
    return { label: 'active subscription', weight: 2 };
  } else if (user.license && user.license.is_expired) {
    return { label: 'expired subscription', weight: 1 };
  }
  return { label: 'no subscription', weight: 0 };
};

const DownloadUsersCsv = () => {
  const { users, isLoading } = useUsers();

  const data = React.useMemo(() => {
    return [
      [
        'first name',
        'name',
        'email',
        'last login',
        '# projects',
        'status',
        'subsription name',
        'subsrcription expiry date',
        'role',
      ],
      ...users
        .map((user) => ({ user, status: getStatus(user) }))
        .sort((a, b) => {
          if (a.status.weight === b.status.weight) return (a.user.email || '').localeCompare(b.user.email || '');
          return b.status.weight - a.status.weight;
        })
        .map(({ user, status }) => [
          user.first_name,
          user.name,
          user.email,
          formatDate(user.last_login_at) || '',
          user.projectCount || 0,
          status.label,
          user.license?.contract.license_type || '',
          formatDate(user.license?.expires_at!) || 'undefined',
          user.memberships.find((m) => m.role === 'admin') ? t('roles.admin') : t('roles.user'),
        ]),
    ];
  }, [users]);

  if (isLoading) {
    return null;
  }
  return (
    <CsvDownloadButton
      fileName={`users_export-${formatDate(new Date(), 'dd/MM/yyyy')}.csv`}
      data={data}
      label={t('users.list.exportCsv')}
    />
  );
};

export default DownloadUsersCsv;
